import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"

function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        months:          "flex flex-row gap-6",
        month:           "flex flex-col gap-4",
        month_caption:   "flex justify-center items-center relative h-7",
        caption_label:   "text-sm font-medium",
        nav:             "flex items-center gap-1",
        button_previous: cn("absolute left-1 h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 inline-flex items-center justify-center rounded-md border border-input hover:bg-accent hover:text-accent-foreground transition-colors"),
        button_next:     cn("absolute right-1 h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 inline-flex items-center justify-center rounded-md border border-input hover:bg-accent hover:text-accent-foreground transition-colors"),
        month_grid:      "w-full border-collapse",
        weekdays:        "flex",
        weekday:         "text-muted-foreground w-8 font-normal text-[0.8rem] text-center",
        week:            "flex w-full mt-2",
        day:             cn(
          "relative p-0 text-center text-sm focus-within:relative focus-within:z-20",
          "[&:has([aria-selected])]:bg-accent",
          "[&:has([aria-selected].day-outside)]:bg-accent/50",
          props.mode === "range"
            ? "first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md"
            : "[&:has([aria-selected])]:rounded-md"
        ),
        day_button:      "h-8 w-8 p-0 font-normal inline-flex items-center justify-center rounded-md text-sm hover:bg-accent hover:text-accent-foreground aria-selected:opacity-100 transition-colors",
        selected:        "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground rounded-md",
        today:           "bg-accent text-accent-foreground rounded-md",
        outside:         "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground",
        disabled:        "text-muted-foreground opacity-50",
        range_start:     "day-range-start rounded-l-md [&>button]:rounded-md",
        range_end:       "day-range-end rounded-r-md [&>button]:rounded-md",
        range_middle:    "aria-selected:bg-accent aria-selected:text-accent-foreground aria-selected:rounded-none",
        hidden:          "invisible",
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation, ...rest }) =>
          orientation === "left"
            ? <ChevronLeft className="h-4 w-4" {...rest} />
            : <ChevronRight className="h-4 w-4" {...rest} />,
      }}
      {...props}
    />
  )
}
Calendar.displayName = "Calendar"

export { Calendar }
